import { GET, POST, PUT, DELETE } from "../../api";

export const LoginPost = async (data) => {
  try {
    const response = await POST("/common/auth/admin-login", data);
    return response;
  } catch (error) {
    throw error;
  }
};
